import { Phone, MessageSquareText } from "lucide-react";
import { smsHref, useSmsMessage } from "@/components/TextUs";
import { WhatsAppIcon } from "@/components/ContactButtons";
import { TEL_HREF, whatsappHref } from "@/lib/contact";

const btn =
  "w-14 h-14 rounded-full bg-primary text-primary-foreground flex items-center justify-center shadow-lg hover:shadow-xl transition-all hover:scale-105";

export default function FloatingButtons() {
  const msg = useSmsMessage();
  return (
    <div data-track-location="floating" className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      <a href={TEL_HREF} className={btn} aria-label="Call Maria at Atlanta Luxury Sprinters">
        <Phone className="w-6 h-6" />
      </a>
      <a href={whatsappHref(msg)} target="_blank" rel="noopener noreferrer" className={btn} aria-label="WhatsApp Maria at Atlanta Luxury Sprinters">
        <WhatsAppIcon className="w-6 h-6" />
      </a>
      <a href={smsHref(msg)} className={btn} aria-label="Text Maria at Atlanta Luxury Sprinters">
        <MessageSquareText className="w-6 h-6" aria-hidden="true" />
      </a>
    </div>
  );
}
